import * as React from "react";

// CSS & SCSS
import "./assets/fonts/inter.css";
import "./assets/fonts/material.css";
import "./assets/fonts/icofont/icofont.css";
import "./assets/fonts/custom.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/sass/styles.scss";
import { AuthProvider } from "./context/AuthContext";
import { ValidationProvider } from "./context/ValidationContext";
import { ProtectedRoute } from "./pages/auth/ProtectedRoute";
// JS & COMPONENTS
import "./i18n";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "./context/Themes";
import { SidebarProvider } from "./context/Sidebar";
import { LoaderProvider } from "./context/Preloader";
import { TranslatorProvider } from "./context/Translator";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { LoginPage, RegisterPage, ForgotPasswordPage } from "./pages/auth";
import { OverviewPage, DocumentationPage, ChangeLogPage, ErrorPage } from "./pages/others";
import { AvatarPage, AlertPage, ButtonPage, ChartPage, TablePage, FieldPage, HeadingPage, ColorPage } from "./pages/ui";
import {
    EcommercePage, AnalyticsPage, CRMPage, UserListPage, UserProfilePage, MyAccountPage,
    ProductListPage, ProductViewPage, ProductUploadPage, InvoiceListPage, InvoiceDetailsPage, OrderListPage, MessagePage,
    NotificationPage, BlankPage, SettingsPage
} from "./pages/main";
import VendorsPage from "./pages/Admin/Vendors";
import ProductCategoriesPage from "./pages/Admin/Product Categories";
import ProductPage from "./pages/Admin/Products";
import ProductShowPage from "./pages/Admin/Products/show";
import ProductEditPage from "./pages/Admin/Products/edit";
import ProductCreatePage from "./pages/Admin/Products/create";
import PaymentMethodsPage from "./pages/Admin/Payment Methods";
import PurchaseIndex from "./pages/Admin/Purchase";
import PurchaseCreatePage from "./pages/Admin/Purchase/create";
import PurchaseEditPage from "./pages/Admin/Purchase/edit";
import SaleCreatePage from "./pages/Admin/Sale/create";
import SaleIndex from "./pages/Admin/Sale";
import SaleEditPage from "./pages/Admin/Sale/edit";
import VendorShow from "./pages/Admin/Vendors/show";
import PetBreedsIndex from "./pages/Admin/Pet Breed";
import PetIndex from "./pages/Admin/Pet";
import CustomerIndex from "./pages/Admin/Customers";
import SpecializationIndex from "./pages/Admin/Doctor Specialization";
import DoctorsIndex from "./pages/Admin/Doctors";
import DoctorCreatePage from "./pages/Admin/Doctors/create";
import DoctorEdit from "./pages/Admin/Doctors/edit";
import AppointmentsIndex from "./pages/Admin/Appointments";
import SurgeryIndex from "./pages/Admin/Surgery";
import GroomingIndex from "./pages/Admin/Grooming";
import LabTestIndex from "./pages/Admin/Lab Test";
import HistoryIndex from "./pages/Admin/History";
import PhysicalExamIndex from "./pages/Admin/Physical Exam";
import RadiologyIndex from "./pages/Admin/Radialogy";
import ProcedureIndex from "./pages/Admin/Procedures";
import AppointmentCreatePage from "./pages/Admin/Appointments/create";
import AppointmentShowPage from "./pages/Admin/Appointments/show";
import StockIndex from "./pages/Admin/Stock";
import VendorReport from "./pages/Admin/Reports/vendorreport";
import DailyClosingReport from "./pages/Admin/Reports/daily_closing_report";
import DashboardPage from "./pages/Admin/Dashboard/dashboard";
import UserManagement from "./pages/Admin/Users";
import RoleIndex from "./pages/Admin/User Roles";
import UserIndex from "./pages/Admin/Users";
import LabTestTemplatePage from "./pages/Admin/Lab Test Template";
import LabTestTemplateCreatePage from "./pages/Admin/Lab Test Template/create";
import LabTestTemplateEditPage from "./pages/Admin/Lab Test Template/edit";
import PetLabTestResultUpload from "./components/Admin/PetLabTestResultUpload";
import PetLabTestResultPage from "./pages/Admin/Lab Test Template/PetLabTestResultPage";
import AllPetLabTests from "./pages/Admin/Pet Lab Test";
import AllPetVaccines from "./pages/Admin/All Pet Vaccines";
import AllPetDeworming from "./pages/Admin/All Pet Dewormings";
import AllPetGrooming from "./pages/Admin/All Pet Groomings";
import AllPetSurgery from "./pages/Admin/All Pet Surgery";
import AllPetRadiology from "./pages/Admin/All Pet Radiology";
import AllInvoice from "./pages/Admin/All Pet Invoices";
import RoleCreate from "./pages/Admin/User Roles/create";
import RoleEdit from "./pages/Admin/User Roles/edit";
import UserCreate from "./pages/Admin/Users/create";
import UserEdit from "./pages/Admin/Users/edit";
import { Navigate } from "react-router-dom";
import CustomerProfilePage from "./pages/Admin/Customers/profile";
import ExpenseCategoryIndex from "./pages/Admin/Expense Category";
import DailyExpenseIndex from "./pages/Admin/Daily Expense";
import DailyExpenseCreate from "./pages/Admin/Daily Expense/create";
import DailyExpenseEdit from "./pages/Admin/Daily Expense/edit";
import EmployeeIndex from "./pages/Admin/Employee";
import SalaryExpenseIndex from "./pages/Admin/Salary Expense";
import UtilityExpenseIndex from "./pages/Admin/Utility Expense";
import FinanceReport from "./pages/Admin/Reports/finance_report";
import StockShow from "./pages/Admin/Stock/StockShow";
import OrderIndexPage from "./pages/Admin/orders";
import OrderShowPage from "./pages/Admin/orders/show";
import BookedAppointmentIndexPage from "./pages/Admin/Appointments/booked-appointment";
import FollowUpIndex from "./pages/Admin/Follow uo";
import CheckUpIndex from "./pages/Admin/Check Up";
import InHouseProductIndex from "./pages/Admin/InHouseProduct/InHouseProductIndex";
import InHouseProductForm from "./pages/Admin/InHouseProduct/InHouseProductForm";
import InHouseProductStock from "./pages/Admin/InHouseProduct/InHouseProductStock";
import InHousePurchaseIndex from "./pages/Admin/InHousePurchase/InHousePurchaseIndex";
import InHousePurchaseCreate from "./pages/Admin/InHousePurchase/InHousePurchaseCreate";
import InHousePurchaseView from "./pages/Admin/InHousePurchase/InHousePurchaseEdit";
import TreatmentIndex from "./pages/Admin/Treatment";
import RemindersPage from "./pages/Admin/Reminders/RemindersPage";




const router = createBrowserRouter([
    // MAIN PAGES
    { path: "/ecommerce", element: <EcommercePage /> },
    { path: "/analytics", element: <AnalyticsPage /> },
    { path: "/crm", element: <CRMPage /> },
    { path: "/forgot-password", element: <ForgotPasswordPage /> },
    { path: "/register", element: <RegisterPage /> },
    { path: "/login", element: <LoginPage /> },
    { path: "/user-list", element: <UserListPage /> },
    { path: "/user-profile", element: <UserProfilePage /> },
    { path: "/my-account", element: <MyAccountPage /> },
    { path: "/product-list", element: <ProductListPage /> },
    { path: "/product-view", element: <ProductViewPage /> },
    { path: "/product-upload", element: <ProductUploadPage /> },
    { path: "/invoice-list", element: <InvoiceListPage /> },
    { path: "/invoice-details", element: <InvoiceDetailsPage /> },
    { path: "/order-list", element: <OrderListPage /> },
    { path: "/message", element: <MessagePage /> },
    { path: "/notification", element: <NotificationPage /> },
    { path: "/blank-page", element: <BlankPage /> },
    { path: "/settings", element: <SettingsPage /> },

    // UI PAGES
    { path: "/avatars", element: <AvatarPage /> },
    { path: "/alerts", element: <AlertPage /> },
    { path: "/buttons", element: <ButtonPage /> },
    { path: "/charts", element: <ChartPage /> },
    { path: "/tables", element: <TablePage /> },
    { path: "/fields", element: <FieldPage /> },
    { path: "/headings", element: <HeadingPage /> },
    { path: "/colors", element: <ColorPage /> },

    // OTHER PAGES
    { path: "/", element: <LoginPage /> },
    { path: "/documentation", element: <DocumentationPage /> },
    { path: "/changelog", element: <ChangeLogPage /> },
    { path: "/error", element: <ErrorPage /> },






    {
        path: "/dashboard",
        element: (
            <ProtectedRoute>
                <DashboardPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/reminders",
        element: (
            <ProtectedRoute>
                <RemindersPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/users",
        element: (
            <ProtectedRoute permission="Users view">
                <UserIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/user-create",
        element: (
            <ProtectedRoute permission="Users create">
                <UserCreate />
            </ProtectedRoute>
        ),
    },
    {
        path: "/user-edit/:id",
        element: (
            <ProtectedRoute permission="Users edit">
                <UserEdit />
            </ProtectedRoute>
        ),
    },
    {
        path: "/users-roles",
        element: (
            <ProtectedRoute permission="User roles view">
                <RoleIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/role-create",
        element: (
            <ProtectedRoute permission="User roles create">
                <RoleCreate />
            </ProtectedRoute>
        ),
    },
    {
        path: "/role-edit/:id",
        element: (
            <ProtectedRoute permission="User roles edit">
                <RoleEdit />
            </ProtectedRoute>
        ),
    },
    {
        path: "/vendor-list",
        element: (
            <ProtectedRoute permission="Vendor view">
                <VendorsPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/vendor-show/:id",
        element: (
            <ProtectedRoute permission="Vendor view">
                <VendorShow />
            </ProtectedRoute>
        ),
    },
    {
        path: "/products-list",
        element: (
            <ProtectedRoute permission="Products view">
                <ProductPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/product-create",
        element: (
            <ProtectedRoute permission="Products create">
                <ProductCreatePage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/product-edit/:slug",
        element: (
            <ProtectedRoute permission="Products edit">
                <ProductEditPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/product-show/:id",
        element: (
            <ProtectedRoute permission="Products view">
                <ProductShowPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/inhouse/products",
        element: (
            <ProtectedRoute permission="Products view">
                <InHouseProductIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/inhouse/product-create",
        element: (
            <ProtectedRoute permission="Products view">
                <InHouseProductForm />
            </ProtectedRoute>
        ),
    },
    {
        path: "/inhouse/product-edit/:id",
        element: (
            <ProtectedRoute permission="Products view">
                <InHouseProductForm />
            </ProtectedRoute>
        ),
    },
    {
        path: "/inhouse/product-stock/:id",
        element: (
            <ProtectedRoute permission="Products view">
                <InHouseProductStock />
            </ProtectedRoute>
        ),
    },
    {
        path: "/inhouse/purchase",
        element: (
            <ProtectedRoute permission="Purchases view">
                <InHousePurchaseIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/inhouse/purchase-create",
        element: (
            <ProtectedRoute permission="Purchases view">
                <InHousePurchaseCreate />
            </ProtectedRoute>
        ),
    },
    {
        path: "/inhouse/purchase-view/:id",
        element: (
            <ProtectedRoute permission="Purchases view">
                <InHousePurchaseView />
            </ProtectedRoute>
        ),
    },
    {
        path: "/purchase-list",
        element: (
            <ProtectedRoute permission="Purchases view">
                <PurchaseIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/purchase-create",
        element: (
            <ProtectedRoute permission="Purchases create">
                <PurchaseCreatePage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/purchase-edit/:id",
        element: (
            <ProtectedRoute permission="Purchases edit">
                <PurchaseEditPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/sales-list",
        element: (
            <ProtectedRoute permission="Sales view">
                <SaleIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/sale-create",
        element: (
            <ProtectedRoute permission="Sales create">
                <SaleCreatePage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/sale-edit/:id",
        element: (
            <ProtectedRoute permission="Sales edit">
                <SaleEditPage />
            </ProtectedRoute>
        ),
    },

    {
        path: "/orders",
        element: (
            <ProtectedRoute permission="Pets view">
                <OrderIndexPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/orders/:id",
        element: (
            <ProtectedRoute permission="Pets view">
                <OrderShowPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/pets",
        element: (
            <ProtectedRoute permission="Pets view">
                <PetIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/customers",
        element: (
            <ProtectedRoute permission="Customers view">
                <CustomerIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/customers-profile/:id",
        element: (
            <ProtectedRoute>
                <CustomerProfilePage />
            </ProtectedRoute>
        ),
    },

    {
        path: "/doctors",
        element: (
            <ProtectedRoute permission="Doctors view">
                <DoctorsIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/doctor-create",
        element: (
            <ProtectedRoute permission="Doctors create">
                <DoctorCreatePage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/doctor-edit/:id",
        element: (
            <ProtectedRoute permission="Doctors edit">
                <DoctorEdit />
            </ProtectedRoute>
        ),
    },
    {
        path: "/appointments",
        element: (
            <ProtectedRoute permission="Appointments view">
                <AppointmentsIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/booked/appointments",
        element: (
            <ProtectedRoute permission="Appointments view">
                <BookedAppointmentIndexPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/appointment-create",
        element: (
            <ProtectedRoute permission="Appointments create">
                <AppointmentCreatePage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/appointments/:id",
        element: (
            <ProtectedRoute>
                <AppointmentShowPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/stock",
        element: (
            <ProtectedRoute>
                <StockIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/stock/show/:productId",
        element: (
            <ProtectedRoute>
                <StockShow />
            </ProtectedRoute>
        ),
    },
    {
        path: "/report/vendors-report",
        element: (
            <ProtectedRoute permission="Reports vendors">
                <VendorReport />
            </ProtectedRoute>
        ),
    },
    {
        path: "/report/daily-closing-report",
        element: (
            <ProtectedRoute permission="Reports daily closing">
                <DailyClosingReport />
            </ProtectedRoute>
        ),
    },
    {
        path: "/report/finance-report",
        element: (
            <ProtectedRoute permission="Reports daily closing">
                <FinanceReport />
            </ProtectedRoute>
        ),
    },



    //////////// Settings//////
    {
        path: "/product-categories",
        element: (
            <ProtectedRoute permission="Settings">
                <ProductCategoriesPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/payment-methods",
        element: (
            <ProtectedRoute permission="Settings">
                <PaymentMethodsPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/pet-breeds",
        element: (
            <ProtectedRoute permission="Settings">
                <PetBreedsIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/doctors-specializations",
        element: (
            <ProtectedRoute permission="Settings">
                <SpecializationIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/appointment-services/surgery",
        element: (
            <ProtectedRoute permission="Settings">
                <SurgeryIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/appointment-services/grooming",
        element: (
            <ProtectedRoute permission="Settings">
                <GroomingIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/appointment-services/follow-ups",
        element: (
            <ProtectedRoute permission="Settings">
                <FollowUpIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/appointment-services/checkups",
        element: (
            <ProtectedRoute permission="Settings">
                <CheckUpIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/treatments",
        element: (
            <ProtectedRoute permission="Settings">
                <TreatmentIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/appointment-services/lab-test",
        element: (
            <ProtectedRoute permission="Settings">
                <LabTestIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/appointment-services/history",
        element: (
            <ProtectedRoute permission="Settings">
                <HistoryIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/appointment-services/physical-exams",
        element: (
            <ProtectedRoute permission="Settings">
                <PhysicalExamIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/appointment-services/radialogy",
        element: (
            <ProtectedRoute permission="Settings">
                <RadiologyIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/appointment-services/procedures",
        element: (
            <ProtectedRoute permission="Settings">
                <ProcedureIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/expense-categories",
        element: (
            <ProtectedRoute permission="Settings">
                <ExpenseCategoryIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/lab-test-templates",
        element: (
            <ProtectedRoute permission="Settings">
                <LabTestTemplatePage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/pet-lab-test-result/:petLabTestId",
        element: (
            <ProtectedRoute>
                <PetLabTestResultPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/lab-test-templates/create",
        element: (
            <ProtectedRoute permission="Settings">
                <LabTestTemplateCreatePage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/lab-test-templates/edit/:id",
        element: (
            <ProtectedRoute permission="Settings">
                <LabTestTemplateEditPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/salary-expenses",
        element: (
            <ProtectedRoute permission="Salary Expenses view">
                <SalaryExpenseIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/utility-expenses",
        element: (
            <ProtectedRoute permission="Utility Expenses view">
                <UtilityExpenseIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/daily-expenses",
        element: (
            <ProtectedRoute permission="Daily Expenses view">
                <DailyExpenseIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/daily-expense-create",
        element: (
            <ProtectedRoute permission="Daily Expenses create">
                <DailyExpenseCreate />
            </ProtectedRoute>
        ),
    },
    {
        path: "/daily-expense-edit/:id",
        element: (
            <ProtectedRoute permission="Daily Expenses edit">
                <DailyExpenseEdit />
            </ProtectedRoute>
        ),
    },
    {
        path: "/employee",
        element: (
            <ProtectedRoute permission="Employee view">
                <EmployeeIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: "/pet-lab-tests",
        element: (
            <ProtectedRoute permission="Pet lab test view">
                <AllPetLabTests />
            </ProtectedRoute>
        ),
    },

    {
        path: "/pet-vaccines",
        element: (
            <ProtectedRoute permission="Pet vaccine view">
                <AllPetVaccines />
            </ProtectedRoute>
        ),
    },
    {
        path: "/pet-dewormings",
        element: (
            <ProtectedRoute permission="Pet deworming view">
                <AllPetDeworming />
            </ProtectedRoute>
        ),
    },
    {
        path: "/pet-groomings",
        element: (
            <ProtectedRoute permission="Pet grooming view">
                <AllPetGrooming />
            </ProtectedRoute>
        ),
    },
    {
        path: "/pet-surgery",
        element: (
            <ProtectedRoute permission="Pet surgery view">
                <AllPetSurgery />
            </ProtectedRoute>
        ),
    },
    {
        path: "/pet-radiology",
        element: (
            <ProtectedRoute permission="Pet radiology view">
                <AllPetRadiology />
            </ProtectedRoute>
        ),
    },
    {
        path: "/pet-invoices",
        element: (
            <ProtectedRoute permission="Pet invoice view">
                <AllInvoice />
            </ProtectedRoute>
        ),
    },

]);


document.addEventListener("wheel", function (e) {
    if (document.activeElement.type === "number") {
        document.activeElement.blur();
    }
});

createRoot(document.getElementById("root")).render(
    <ThemeProvider>
        <LoaderProvider>
            <TranslatorProvider>
                <SidebarProvider>
                    <AuthProvider>
                        <ValidationProvider>

                            <RouterProvider router={router} />
                        </ValidationProvider>
                    </AuthProvider>
                </SidebarProvider>
            </TranslatorProvider>
        </LoaderProvider>
    </ThemeProvider>
);